<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Change Deployment Name</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <form [formGroup]="deploymentNameChangeForm" autocomplete="off" spellcheck="false">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Enter New Deployment Name</mat-label>
        <input matInput placeholder="Enter New Deployment Name" formControlName='newDepName'>
        <mat-error *ngIf="deploymentNameChangeForm.get('newDepName').touched && deploymentNameChangeForm.get('newDepName').errors?.required">Deployment name Required*</mat-error>
        <mat-error *ngIf="deploymentNameChangeForm.get('newDepName').touched && deploymentNameChangeForm.get('newDepName').errors?.pattern">Deployment must contain small case letters and numbers. It must start with a letter. Deployment name should be more than 2 and less than 12 characters.</mat-error>
        <button type="button"
                class="mat-icon-button"
                data-placement="right"
                matSuffix
                matTooltip="Enter deployment name which uniquely identifies your HPC cluster. It can contain only small case letters and numbers. It must start with a letter. Deployment name should be more than 2 and less than 12 characters."
                matTooltipPosition="right"
                style="color: var(--s-primary-color) !important">
          <mat-icon>info</mat-icon>
        </button>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button [disabled]="!deploymentNameChangeForm.valid" type="button" class="btn btn-primary" (click)="onSubmit()">Update</button>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default" zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"
               name="updateCredential"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
